module.exports = __webpack_public_path__ + "img/banner_hk.5336ccd6.jpg";